export const GET_PROJECTS_REQUEST = "GET_PROJECTS_REQUEST";
export const GET_PROJECTS_REQUEST_SUCCESS = "GET_PROJECTS_REQUEST_SUCCESS";
export const CREATE_PROJECT_REQUEST = "CREATE_PROJECT_REQUEST";
export const CREATE_PROJECT_REQUEST_SUCCESS = "CREATE_PROJECT_REQUEST_SUCCESS";

export const getProjects = () => ({
    type: GET_PROJECTS_REQUEST
});

export const createProject = ( name : string, description?: string, startDate?: string, endDate?: string, projectType?: string ) => ({
    type: CREATE_PROJECT_REQUEST, 
    payload: {
        name,
        description,
        startDate,
        endDate,
        projectType
    }
});